<template>
  <div style="margin-top: 15px" v-loading="loading">
    <div class="searchBar">
      <el-form label-position="left" :inline="true">
        <el-form-item label="NID">
          <el-input v-model="params.nid" />
        </el-form-item>
        <!--        <el-form-item label="设备名">-->
        <!--          <el-input v-model="params.nickname"/>-->
        <!--        </el-form-item>-->
        <el-form-item label="序列号">
          <el-input v-model="params.sn" />
        </el-form-item>
        <el-form-item label="硬件序列号">
          <el-input v-model="params.hsn" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="params.begin"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateTable('query')">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 15px;font-size: 12px">
      <el-table
        class="factory-table"
        ref="multipleTable"
        :data="tableData"
        style="width: 100%,text-align:center"
        element-loading-text="数据正在加载中"
        @selection-change="handleSelectionChange"
        :header-cell-style="headClass"
        :row-style="rowClass"
      >
        <!-- <el-table-column type="selection" width="60"></el-table-column> -->
        <el-table-column prop="nid" label="NID"></el-table-column>
        <el-table-column prop="sn" label="硬件序列号"></el-table-column>
        <el-table-column label="型号类别">
          <template slot-scope="scope">{{ntIdDesc(scope.row.ntId)}}</template>
        </el-table-column>
        <el-table-column label="设备型号 ">
          <template slot-scope="scope">{{scope.row.model==null?'---':scope.row.model}}</template>
        </el-table-column>
        <el-table-column prop="netMode" label="网络类型">
          <template slot-scope="scope">{{scope.row.netMode === 1 ? '2G' : 'WIFI'}}</template>
        </el-table-column>
        <el-table-column prop="rentMode" label="是否单机">
          <template slot-scope="scope">{{scope.row.rentMode === 0 ? '是' : '否'}}</template>
        </el-table-column>
        <el-table-column prox="online" label="联网状态">
          <template slot-scope="scope">
            <el-row type="flex" style="margin-right: 10px;margin-left: 10px">
              <div
                v-if="scope.row.online"
                style="background-color: limegreen;width: 10px;height:10px;border-radius: 50%"
              ></div>
              <div
                v-else
                style="background-color: #cd0000;width: 10px;height:10px;border-radius: 50%"
              ></div>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="工作状态">
          <template slot-scope="scope">
            <div @click="closeDevice(scope.row)" v-if="scope.row.status" style="cursor: pointer;">
              <i class="el-icon-sunny" style="color:orange"></i>
            </div>
            <div @click="openDevice(scope.row)" v-else style="cursor: pointer;">
              <i class="el-icon-moon" style="color:blue"></i>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="openAccountNum" label="联网时间"></el-table-column>-->
        <!--        <el-table-column prop="totalDevices" label="断网时间"></el-table-column>-->
        <el-table-column prop="lockMark" label="锁定">
          <template slot-scope="scope">
            <div v-if="!scope.row.lockMark" @click="lock(scope.row.nid)">
              <icon style="cursor: pointer" name="unlock" :scale="2" />
            </div>
            <div v-else @click="showUnlockDialog(scope.row)">
              <icon style="cursor: pointer" name="lock" :scale="2"></icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sn" label="序列号">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.sn" placement="top-start">
              <span>查看</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="mac" label="mac">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.mac" placement="top-start">
              <span>查看</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click="curRow=scope.row;controlDialogVisible=true"
            >操作</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
        @current-change="handleCurrentChange"
        :current-page="params.pageId"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="unLockDialogVisible"
      :title="`sn: ${unlockDevice.sn} nid: ${unlockDevice.nid}`"
    >
      <el-form>
        <el-form-item label="解锁天数">
          <el-input style="width: 150px" v-model="unlockDays" />
        </el-form-item>
      </el-form>
      <div>
        <el-button :loading="unlockLoading" @click="unlock">解锁</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="操作"
      :visible.sync="controlDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-button
        type="primary"
        size="small"
        @click="updateRentMode(1)"
        v-if="curRow.rentMode==0"
      >开启租赁</el-button>
      <el-button
        type="primary"
        size="small"
        @click="updateRentMode(0)"
        v-if="curRow.rentMode==1"
      >关闭租赁</el-button>
      <el-button type="primary" size="small" @click="resetGsm(curRow)">重置gsm</el-button>
      <el-button type="primary" size="small" @click="restore(curRow)">恢复出厂设置</el-button>
      <el-button type="primary" size="small" @click="setType(curRow)">型号设置</el-button>
    </el-dialog>

    <el-dialog :visible.sync="typeDialogVisible" width="40%" title="设备型号设置" :before-close="cancel">
      <el-form ref="typeForm">
        <el-form-item
          label="型号设为："
          :rules="{required: true, message: '请选择设备型号', trigger: 'change'}"
        >
          <el-select v-model="mid" filterable placeholder="请选择设备型号" style="width:250px">
            <el-option
              v-for="item in typeOptions"
              :key="item.mid"
              :label="item.name"
              :value="item.mid"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="danger" size="small" @click="typeDialogVisible=false">取消</el-button>
        <el-button type="primary" size="small" @click="handleSetType">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'deviceMng',
  data: () => ({
    loading: false,
    pageNum: 10,
    params: {
      size: 10,
      pageId: 1,
      nickname: '',
      nid: '',
      sn: '',
      hsn: '',
      posttime: ''
    },
    total: 0,
    tableData: [],
    multipleSelection: [],
    unlockDays: 0,
    unLockDialogVisible: false,
    unlockDevice: {},
    unlockLoading: false,
    controlDialogVisible: false,
    curRow: {},
    typeDialogVisible: false,
    typeOptions: [],
    mid: ''
  }),
  created () {
    this.updateTable()
  },
  methods: {
    showUnlockDialog (item) {
      this.unlockLoading = false
      this.unlockDevice = item
      this.unLockDialogVisible = true
    },
    updateRentMode (actionValue) {
      const urmLoading = this.$loading({
        lock: true,
        text: '操作执行中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get('/smartWaterPurify/setParam.do', {
          params: {
            nid: this.curRow.nid,
            action: 82,
            actionValue: actionValue,
            sync: true
          }
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.updateTable()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((error) => {
          this.$message.error('系统异常!请与管理员联系!')
        })
        .finally(() => {
          urmLoading.close();
        })
    },
    closeDevice ({
      nid
    }) {
      this.loading = true
      axios
        .get('/srsDevice/close.do', {
          params: {
            nid,
            sync: true
          }
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.updateTable()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((error) => {
          this.$message.error('系统异常!请与管理员联系!')
        })
        .finally(() => {
          this.loading = false
        })

    },
    openDevice ({
      nid
    }) {
      this.loading = true
      axios
        .get('/srsDevice/open.do', {
          params: {
            nid,
            sync: true
          }
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.updateTable()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('系统异常!请与管理员联系!')
        })
        .finally(() => {
          this.loading = false
        })
    },
    lock (nid) {
      console.log('clock');
      this.loading = true
      axios
        .get('/srsDevice/lock.do', {
          params: {
            nid,
            sync: true
          }
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.updateTable()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((error) => {
          this.$message.error('系统异常!请与管理员联系!')
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlock () {
      this.unlockLoading = true
      if (this.unlockDays <= 0 && this.unlockDays > 7) {
        this.$message.error('解锁天数 1 ~ 7 天')
      }
      axios
        .get('/srsDevice/unlock.do', {
          params: {
            nid: this.unlockDevice.nid,
            sync: true,
            days: this.unlockDays
          }
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.updateTable()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('系统异常!请与管理员联系!')
        })
        .finally(() => {
          this.unLockDialogVisible = false
        })
    },
    updateTable (val) {
      if (val == 'query') {
        this.params.pageId = 1
      }
      this.loading = true
      let params = {}
      Object.keys(this.params).forEach(k => {
        if (this.params[k] !== '') {
          params[k] = this.params[k]
        }
      })
      axios
        .get('/admin/smart/list.do', {
          params
        })
        .then(({
          data
        }) => {
          if (data.status === '200') {
            this.tableData = data.data
            this.total = data.totalCount
          } else {
            this.$message.error(data.message)
          }

        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClass ({
      row,
      rowIndex
    }) {
      if (rowIndex % 2 == 0) {
        return 'background:#F1F2F7;'
      } else {
        return 'background:white;'
      }
      return ''
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    headClass ({
      row,
      rowIndex
    }) {
      if (rowIndex == 0) {
        return ''
      }
      return ''
    },
    handleSizeChange (val) {
      this.params.pageNum = val;
      this.updateTable();
    },
    handleCurrentChange (val) {
      this.params.pageId = val;
      this.updateTable();
    },

    resetGsm ({
      nid,
      sn
    }) {
      this.$confirm(`是否重置gsm？`, `当前设备（sn：${sn}  nid：${nid}）`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios
          .get('/admin/smart/restartGSM.do', {
            params: {
              nid,
              sync: true
            }
          })
          .then(res => {
            if (res.data.status === '200') {
              this.$message.success('重置成功')
              this.updateTable()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch(err => {
            this.$message.error(err.data.message)
          })
      })
    },
    restore ({
      nid,
      sn
    }) {
      this.$confirm(`是否恢复出厂设置？`, `当前设备（sn：${sn}  nid：${nid}）`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios
          .get('/admin/smart/recovery.do', {
            params: {
              nid,
              sync: true
            }
          })
          .then(res => {
            if (res.data.status === '200') {
              this.$message.success('恢复出厂设置成功')
              this.updateTable()
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch(err => {
            this.$message.error(err.data.message)
          })
      })
    },

    ntIdDesc (ntId) {
      if (ntId == 1024) {
        return "商用净水器"
      } else if (ntId == 1030) {
        return "家用净水器";
      } else if (ntId == 1033) {
        return "洗头机";
      } else if (ntId == 1106) {
        return "全屋纯水机";
      }
    },

    cancel () {
      this.typeDialogVisible = false
    },
    setType (row) {
      let thiz = this;
      console.log(row)
      axios.get(this.$store.getters.getApiValue + '/equipmentModel/list.do', {
        params: {
          ntId: row.ntId
        }
      }).then(function (response) {
        var data = response.data
        if (data.status == '200') {
          thiz.controlDialogVisible = false
          thiz.typeOptions = data.data;
          thiz.typeDialogVisible = true;
        } else {
          thiz.$message.error(data.message)
        }
      }).catch(function (error) {
        console.log(error)
        thiz.$message.error('系统异常!请与管理员联系!')
      })
    },
    handleSetType () {
      let thiz = this;
      if (this.mid == '') {
        this.$message.warning('请选择设备型号')
        return
      }
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/setMid.do', {
          params: {
            nids: thiz.curRow.nid,
            mid: thiz.mid
          }
        })
        .then(function (response) {
          var data = response.data
          if (data.status == '200') {
            thiz.$message.success('设置成功!')
            thiz.typeDialogVisible = false;
            thiz.updateTable()
            thiz.mid = ''
          } else {
            thiz.mid = ''
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
          thiz.$message.error('系统异常!请与管理员联系!')
        })
    }
  }
}
</script>

<style scoped>
.searchBar/deep/.el-input {
  width: 150px;
}

.factory-table {
  font-size: 12px;
}
</style>
